import { useLocation } from 'react-router-dom';

import {
  CLINICOS_FORGOT_PASSWORD_URL,
  CLINICOS_HOME_URL,
  CLINICOS_SIGN_IN_URL,
  CLINICOS_SIGN_UP_URL,
  resolveClinicOSAuthSurface,
} from '@/utils/clinicos';

import styles from './index.module.scss';

/**
 * Contextual ClinicOS links under every Logto experience card.
 * Links go to Gateway (cloud.quraco.com) so each action starts a fresh OIDC
 * session — bare /sign-in?app_id=… on auth.quraco.com has no interaction and 422s.
 */
const ClinicOSAuthFooter = () => {
  const { pathname } = useLocation();
  const surface = resolveClinicOSAuthSurface(pathname);

  const signIn = { href: CLINICOS_SIGN_IN_URL, label: 'Sign in' };
  const signUp = { href: CLINICOS_SIGN_UP_URL, label: 'Sign up' };
  const forgot = { href: CLINICOS_FORGOT_PASSWORD_URL, label: 'Forgot password' };
  const home = { href: CLINICOS_HOME_URL, label: 'Home' };

  const links =
    surface === 'sign-in'
      ? [signUp, forgot, home]
      : surface === 'register'
        ? [signIn, forgot, home]
        : surface === 'forgot'
          ? [signIn, signUp, home]
          : [signIn, signUp, forgot, home];

  return (
    <nav className={styles.footer} aria-label="ClinicOS account links">
      {links.map((link) => (
        <a key={link.label} className={styles.link} href={link.href}>
          {link.label}
        </a>
      ))}
    </nav>
  );
};

export default ClinicOSAuthFooter;
